export default __webpack_public_path__ + "media/react/mcat/pages/lesson_groups/assets/not_started-b4cdc2fefc0b50fef9773e59b9a48feb.png";